<template>
  <div
    class="flex mb-6"
    @mouseleave="setHover(null)"
  >
    <div class="font-bold pt-1 mr-2">
      {{ __('components.rating.title') }}
    </div>
    <div
      v-for="i in 5"
      :key="i"
      :class="{'cursor-pointer': !active}"
      @mouseenter="setHover(i)"
      @click="select(i)"
    >
      <svg
        :data-score="i"
        height="25"
        width="25"
        viewBox="0 0 43.56 43.56"
      >
        <linearGradient
          :id="i"
          x1="0"
          x2="100%"
          y1="0"
          y2="0"
        >
          <stop
            :offset="active >= i || hover >= i ? '100%' : '0%'"
            stop-color="#ffd055"
          />
          <stop
            :offset="active >= i || hover >= i ? '100%' : '0%'"
            stop-color="#d8d8d8"
          />
        </linearGradient>
        <polygon
          points="19.8,2.2,6.6,43.56,39.6,17.16,0,17.16,33,43.56"
          :fill="`url(#${i})`"
          :filter="`url(#${i})`"
          stroke="#fff"
        />
        <polygon
          points="19.8,2.2,6.6,43.56,39.6,17.16,0,17.16,33,43.56"
          :fill="`url(#${i})`"
          stroke="#999"
          stroke-width="0"
          stroke-linejoin="miter"
        />
        <polygon
          points="19.8,2.2,6.6,43.56,39.6,17.16,0,17.16,33,43.56"
          :fill="`url(#${i})`"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    shoutOut: {
      type: Object,
      required: true,
    },

    initialRating: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data () {
    return {
      active: this.initialRating ?  this.initialRating / 20 : null,
      hover: null,
    };
  },

  methods: {
    select (i) {
      if (!this.active) {
        this.hover = null;
        this.active = i;

        axios.post(this.localeRoute('frontend.shout-out.rating', [this.shoutOut]), {
          rating: i * 20,
        });
      }
    },

    setHover (i) {
      if (!this.active) {
        this.hover = i;
      }
    },
  },
};
</script>
